var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"baikal-attraction",class:_vm.className},[_c('BaikalSlider',{attrs:{"slides":_vm.slides}}),_c('div',{staticClass:"baikal-attraction__descr"},[_vm._t("default")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }